// extracted by mini-css-extract-plugin
export var card = "_qe-0";
export var content = "_qe-2";
export var details = "_qe-3";
export var icon = "_qe-1";
export var iconBlue = "_qe-5";
export var iconBrand = "_qe-4";
export var iconGrayBlue = "_qe-6";
export var iconGreen = "_qe-7";
export var iconIndigo = "_qe-8";
export var iconOrange = "_qe-9";
export var iconPurple = "_qe-a";
export var iconRed = "_qe-b";
export var iconWarning = "_qe-c";